let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5JR52")).then(() => parcelRequire('3aABw'));